import { useMemo, useState } from "react";
import useClientConfig from "../common/hooks/clientConfigHook"
import { readField, writeField } from "../common/utils/objectUtilities";
import { useParticipantByQuery } from "../reducers/participantSlice";
import { ReactNodeDialog } from "../common/utils/dialogUtlities";
import CustomForm from "../common/components/CustomForm";
import Button from "../common/components/Button";
import { useTranslation } from "react-i18next";
import { useEpcr } from "../reducers/epcrSlice";
import Icon from "../common/components/Icon";
import { useJob } from "../reducers/jobSlice";

const ParticipantButton = ({ participant }) => {
    const { t } = useTranslation();
    const clientConfig = useClientConfig();
    const [showDetails, setShowDetails] = useState(false);

    return participant && <>
        <ReactNodeDialog showModal={showDetails} onClose={() => setShowDetails(false)} title={t('participantDetails')} size="lg">
            <CustomForm def={clientConfig.participantForm} data={participant} readonly></CustomForm>
        </ReactNodeDialog>
        <Button onClick={() => setShowDetails(true)} variant="default"><Icon variant="solid" kind="id-card"></Icon> {t('participant', { count: 1 })}</Button>
    </>
}

export const JobParticipantButton = ({ jobid }) => {
    const job = useJob(jobid);
    const clientConfig = useClientConfig();
    const query = useMemo(() => Object.entries(clientConfig.participantJobQueryMapping).reduce((obj, [src, dest]) => { writeField(obj, dest, readField(job, src)); return obj; }, {}), [clientConfig.participantJobQueryMapping, job]);
    const participant = useParticipantByQuery(query);

    return participant && Object.keys(clientConfig.participantJobQueryMapping).some(f => readField(job, f)) && <ParticipantButton participant={participant}></ParticipantButton>
}

export const EpcrParticipantButton = ({ pcrid }) => {
    const epcr = useEpcr(pcrid);
    const clientConfig = useClientConfig();
    const query = useMemo(() => Object.entries(clientConfig.participantEpcrQueryMapping).reduce((obj, [src, dest]) => { writeField(obj, dest, readField(epcr, src)); return obj; }, {}), [clientConfig.participantEpcrQueryMapping, epcr]);
    const participant = useParticipantByQuery(query);

    return participant && Object.keys(clientConfig.participantEpcrQueryMapping).some(f => readField(epcr, f)) && <ParticipantButton participant={participant}></ParticipantButton>
}